import React from 'react';

const ManageS3Access = () => {
  return <div>Manage S3 Access</div>;
};

export default ManageS3Access;